const brickFaq = {
    init: function () {
        $(".brick-faq .question").on("click", function () {
            let $thisQuestion = $(this);
            let $thisAnswer = $(this).parent().find('.answer');
            let $thisBrick = $(this).parents('.questions-list');

            $thisBrick.find('.question').not($thisQuestion).removeClass('active');
            $thisBrick.find('.answer').not($thisAnswer).slideUp('fast');
            
            $(this).toggleClass('active');
            $thisAnswer.slideToggle();
        });
    }
}

export { brickFaq };